import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() id: string;
  constructor( private rest: ContentService,) { }

  ngOnInit(): void {
    if(this.rest.get_reload()!=null){
      location.reload()
     this.rest.remove_reload()
  }
  }
  
  career() {
    window.location.href = '/career';
   

  }
  aboutUs() {
    window.location.href = '/about-us';
   
  }
  products() {
    window.location.href = '/products';
   
  }
  daicel_group() {
    window.location.href = '/daicel-group';
   
  }
  csr_page() {
    window.location.href = '/csr';
   
  }
  news_events() {
    window.location.href = '/news-events';
   
  }
  contact_us() {
    window.location.href = '/contact-us';
   

  }
  th() {
    window.location.href = '/th/preview?id=' + this.id;
   

  }
  home() {
    window.location.href = '/';
   
  }

  preview(data) {

    window.location.href = '/preview?id=' + data;
   
  }
  async onSearch(keyword) {

    window.location.href = '/search?keyword=' + keyword;
   
  }
  go(j, item) {

    window.location.href = '/year?month=' + j + '&year=' + item
   

  }


}
